export enum MutationTypes {
    SET_TOTAL = 'SET_TOTAL',
    SET_SUMMARY = 'SET_SUMMARY',
    SET_INVOICE_ID = 'SET_INVOICE_ID',
    SET_MONTHLY_PAYMENT = 'SET_MONTHLY_PAYMENT',
}
